import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '.';
import parse from 'html-react-parser';

export const useCMSContent = (): {
    // eslint-disable-next-line no-unused-vars
    getContentAsString: (key: string, value?: Record<string, any>) => any;
    // eslint-disable-next-line no-unused-vars
    getContentAsElement: (key: string, value?: Record<string, any>) => any;
} => {
    const { cmsData } = useAppSelector((state) => state.global);
    const { t } = useTranslation();

    const getContentAsString = (key: string, value?: Record<string, any>): string => {
        let htmlString = cmsData ? t(cmsData[key] ?? key, value) : key;
        return htmlString;
    };

    const getContentAsElement = (key: string, value?: Record<string, any>): JSX.Element => {
        let htmlString = cmsData ? t(cmsData[key] ?? key, value) : key;
        const content = parse(htmlString);
        return <>{content}</>;
    };

    // return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
    return {
        getContentAsString,
        getContentAsElement
    };
};
